import { render, staticRenderFns } from "./loginPwd.vue?vue&type=template&id=08a31938&scoped=true"
import script from "./loginPwd.vue?vue&type=script&lang=js"
export * from "./loginPwd.vue?vue&type=script&lang=js"
import style0 from "./loginPwd.vue?vue&type=style&index=0&id=08a31938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a31938",
  null
  
)

export default component.exports